import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, ReqX, ResponsiveX, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XDiv, XImage, XScroll, XText } from "IZOX/_X";
import _ from "lodash";
import NotiUtils from "../../../../../../shared/_utils/NotiUtils";
import QUICKUI from "shared/QUICKUI";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PANoti extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      notiDocs: []
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetNoti();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PANoti.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetNoti = async () => {
    let res = await ReqX.SendBE("/Web/Agent/GetNoti");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        notiDocs: payload
      });
    }
  }

  _toDoc = (_id) => {
    
  }

  renderNotiBox(doc, idx){
    let {_id, policyNo, runtimeStatus, createdAt} = doc;
    let {label, color} = NotiUtils.GetStatus(runtimeStatus);
    return (
      <XButton notInjectColor key={idx} padding={0} 
        onPress={() => this._toDoc(_id)}
        width={207} height={52}
        mB={8}
        style={{boxShadow: `0px 2px 2px 2px ${ColorX.CSS("lightGrey", 0.8)}`}}>
        <HStack bgColor={ColorX.CSS("pureWhite")} fullHeight>
          <XDiv bgColor={color} fullHeight width={5}/>
          <HStack flexGrow={1} fitWidthToContent>
            <VStack HAlign="[" pH={5}>
              <XText fontSize={12}>
                {LocaleX.Parse(label)}
              </XText>
              <XText fontSize={12} color={ColorX.CSS("Gray4")}>
                {ZTime.Moment(createdAt).format("DD/MM/YYYY")}
              </XText>
            </VStack>
            <Spacer/>
            <HStack fitWidthToContent pH={5}>
              <XText>
                {`#${policyNo}`}
              </XText>
            </HStack>
          </HStack>
        </HStack>
      </XButton>
    );
  }

  renderNotiBoxM(doc, idx){
    let {_id, policyNo, runtimeStatus, createdAt} = doc;
    let {label, color} = NotiUtils.GetStatus(runtimeStatus);
    return (
      <XButton notInjectColor key={idx} padding={0} 
        onPress={() => this._toDoc(_id)}
        fullWidth height={52}
        mB={8}
        style={{boxShadow: `0px 2px 2px 2px ${ColorX.CSS("lightGrey", 0.8)}`}}>
        <HStack bgColor={ColorX.CSS("pureWhite")} fullHeight>
          <XDiv bgColor={color} fullHeight width={5}/>
          <HStack flexGrow={1} fitWidthToContent>
            <VStack HAlign="[" pH={5}>
              <XText fontSize={12}>
                {LocaleX.Parse(label)}
              </XText>
              <XText fontSize={12} color={ColorX.CSS("Gray4")}>
                {ZTime.Moment(createdAt).format("DD/MM/YYYY")}
              </XText>
            </VStack>
            <Spacer/>
            <HStack fitWidthToContent pH={5}>
              <XText>
                {`#${policyNo}`}
              </XText>
            </HStack>
          </HStack>
        </HStack>
      </XButton>
    );
  }

  renderNotiList(){
    let {notiDocs} = this.state;
    if(_.isEmpty(notiDocs)){
      return QUICKUI.NoDocs({
        EN: "There is no notification.",
        TC: "沒有任何通知。"
      }, 12, {pV: 5});
    }
    return (
      <XScroll>
        {_.map(notiDocs, (o, i) => {
          return this.renderNotiBox(o, i);
        })}
      </XScroll>
    );
  }

  renderNotiListM(){
    let {notiDocs} = this.state;
    if(_.isEmpty(notiDocs)){
      return QUICKUI.NoDocs({
        EN: "There is no notification.",
        TC: "沒有任何通知。"
      }, 12, {pV: 5});
    }
    return (
      <XScroll maxHeight={200} pH={10}>
        {_.map(notiDocs, (o, i) => {
          return this.renderNotiBoxM(o, i);
        })}
      </XScroll>
    );
  }

  renderNormal(){
    return (
      <VStack width={243} bgColor={ColorX.CSS("NotQuiteWhite")} p={16} fullHeight>
        <HStack HAlign="[" spacing={8} mB={10}>
          <XImage source={"/Images/Icons/ic_bell.svg"}/>
          <XText color={ColorX.CSS("Axit")} style={{fontWeight: 500}}>
            {LocaleX.Parse({
              EN: "Notification",
              TC: "通知"
            })}
          </XText>
        </HStack>
        {this.renderNotiList()}
      </VStack>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth bgColor={ColorX.CSS("NotQuiteWhite")} p={16} spacing={16}>
        {this.renderNotiListM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal(),
    });
  }

}

export default observer(PANoti);
